import { getRequest } from '../services/requestHandler';
import { HeadWeightNumberLookup } from '../models';

export const getHeadWeightNumberLookups = async () => {
  const url = 'headWeight/getHeadWeightNumberLookups?useCache=false';
  const response = await getRequest<HeadWeightNumberLookup>('GetHeadWeightNumberLookups', url);
  return response;
};
